import React from "react";
import dl320 from "../../../assests/HPE/updated-assets/s_dl320.webp";
import dl340 from "../../../assests/HPE/updated-assets/s_dl340.webp";
import dl360 from "../../../assests/HPE/updated-assets/s_dl360.webp";
import dl380 from "../../../assests/HPE/updated-assets/s_dl380.webp";
import dl380a from "../../../assests/HPE/updated-assets/s_dl380a.webp";
import ml350a from "../../../assests/HPE/updated-assets/s_ml350.webp";
import { Download } from "lucide-react";
// import Button from "../../common/Button";

const data = [
  {
    image: dl320,
    title: "HPE ProLiant Compute DL320 Gen12",
    description:
      "HPE ProLiant Compute DL320 Gen12 models are optimized for workloads that require high core density and efficient multithreading.",
    features: [
      "Intel Xeon 6 processors",
      "3.5 GHz maximum",
      "4 TB DRR5 up to 6400 MT/s",
      "6 PCIe Gen5 and 2 OCP 3.0 slots",
    ],
    solutionBrief:
      "/HPE ProLiant Compute DL320 Gen12, powered by Intel Xeon 6-a50012395enw.pdf",
  },
  {
    image: dl340,
    title: "HPE ProLiant Compute DL340 Gen12",
    description:
      "The HPE ProLiant Compute DL340 Gen12 is a 2U 1P server that offers three CTO chassis that support SFF, LFF, and  GPU configurations.",
    features: [
      "Intel Xeon 6 processors",
      "3.5 GHz maximum",
      "4 TB DRR5 up to 6400 MT/s",
      "6 PCIe Gen5 and 2 OCP 3.0 slots",
    ],
    quickSpecs: "/HPE ProLiant Compute DL340 Gen12-a50004261enw.pdf",
  },
  {
    image: dl360,
    title: "HPE ProLiant Compute DL360 Gen12",
    description:
      "HPE DL360 Gen12 is a compact 1U server delivering high performance and fast data transfer for demanding workloads.",
    features: [
      " Intel Xeon 6 processors",
      "4.0 GHz maximum",
      " 8 TB DRR5 up to 6400 MT/s",
      "3 PCIe Gen5 and 2 OCP 3.0 slots",
    ],
    solutionBrief:
      "/HPE ProLiant Compute DL360 Gen12, powered by Intel Xeon 6-a50012356enw.pdf",
    quickSpecs: "/HPE ProLiant Compute DL360 Gen12-a50006984enw.pdf",
  },
  {
    image: dl380,
    title: "HPE ProLiant Compute DL380 Gen12",
    description:
      "HPE DL380 Gen12 is a 2U 2P scalable server delivering high performance, memory density, and fast data transfer for demanding applications.",
    features: [
      "Intel Xeon 6 processors",
      "3.9 GHz maximum",
      "8 TB DRR5 up to 6400 MT/s",
      "8 PCIe Gen5 and 2 OCP 3.0 slots",
    ],
    solutionBrief:
      "/HPE ProLiant Compute DL380 Gen12, powered by Intel Xeon 6-a50012357enw.pdf",
    quickSpecs: "/HPE ProLiant Compute DL380 Gen12-a00073551enw.pdf",
  },
  {
    image: dl380a,
    title: "HPE ProLiant Compute DL380a Gen12",
    description:
      "HPE DL380a Gen12 is a 4U 2P rack server offering powerful GPU-accelerated performance on a highly scalable architecture.",
    features: [
      "Intel Xeon 6 processors",
      "2.4 GHz maximum",
      "4 TB DRR5 up to 6400 MT/s",
      "6 expansion slots",
    ],
    quickSpecs: "/HPE ProLiant Compute DL380a Gen12-a00047453enw.pdf",
  },
  {
    image: ml350a,
    title: "HPE ProLiant Compute ML350 Gen12",
    description:
      "HPE ML350 Gen12 is a 2P tower server (rackable) offering strong performance, security, reliability, and expandability for diverse environments.",
    features: [
      "Intel Xeon 6 processors",
      "2.4 GHz maximum",
      "4 TB DRR5 up to 6400 MT/s",
      "6 expansion slots",
    ],
    quickSpecs: "/HPE ProLiant Compute ML350 Gen12-a50006995enw.pdf",
  },
];

const Advantage = () => {
  return (
    <section className="bg-page3-bg bg-cover bg-center bg-no-repeat py-20 md:py-36">
      <div className="container inline-padding">
        <div className="flex flex-col md:flex-row justify-between items-start gap-6 mb-6 md:mb-8">
          <h1 className="text-grey-08 w-full md:w-3/4 xl:w-2/3">
            The HPE ProLiant & Intel Advantage: Experience the Difference
          </h1>
          {/* <a href="#masthead" className="inline-flex mb-4">
            <Button text="Enquire now" styles="text-nowrap" />
          </a> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-6">
          {data.map(
            (
              {
                image,
                title,
                description,
                features,
                quickSpecs,
                solutionBrief,
              },
              index
            ) => {
              return (
                <div
                  className="col-span-12 md:col-span-6 lg:col-span-4"
                  key={index}
                >
                  <div className="p-4 bg-white rounded-[1.375rem] border border-solid border-grey-01 h-full">
                    <img src={image} alt="dl20" className="mb-4 rounded-lg" />
                    <div className="flex items-center gap-2 flex-wrap mb-6">
                      {solutionBrief && (
                        <a
                          href={`/pdfs/hpe-material/${solutionBrief}`}
                          className="py-2 px-3 rounded-3xl b4 text-blue-05 hover:bg-blue-06 hover:text-white border border-solid border-blue-05 flex gap-2 items-center transition-all"
                          download
                        >
                          <span>Solution brief</span>
                          <Download size={16} />
                        </a>
                      )}
                      {quickSpecs && (
                        <a
                          href={`/pdfs/hpe-material/${quickSpecs}`}
                          className="py-2 px-3 rounded-3xl b4 text-blue-05 hover:bg-blue-06 hover:text-white border border-solid border-blue-05 flex gap-2 items-center transition-all"
                          download
                        >
                          <span>Quick specs</span>
                          <Download size={16} />
                        </a>
                      )}
                    </div>
                    <p className="b1 text-grey-08 mb-2">{title}</p>
                    <p className="b3 text-grey-04 mb-4">{description}</p>

                    <p className="b2 text-grey-06 mb-2">Key features</p>
                    <ul className="b3 text-grey-04 list-disc pl-4">
                      {features.map((feature, index) => {
                        return <li key={index}>{feature}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </section>
  );
};

export default Advantage;
